import { TapResponse } from '@iotize/tap';

import { InterfaceService } from '../generated/service';

declare module '../generated/service' {
  export interface InterfaceService {
    getAppUrl(): Promise<TapResponse<string>>;
    getAndroidApplicationId(): Promise<TapResponse<string>>;
    putAndroidApplicationId(value: string): Promise<TapResponse<void>>;
  }
}

InterfaceService.prototype.getAppUrl = async function () {
  const appPath = await this.getAppPath();
  if (appPath.isSuccessful()) {
    let body: string = appPath.body();
    if (body.match(/^\$[1-6]\//)) {
      const code = body.substring(0, 3);
      const content = body.substring(3);
      switch (code) {
        case '$1/':
          body = `https://user.cloud.iotize.com/users/${content}`;
          break;
        case '$2/':
          body = `http://${content}`;
          break;
        case '$5/':
          body = `https://user.cloud.iotize.com/users/${content}`;
          break;
        default:
          body = '';
      }
      appPath.setBody(body);
    }
  }
  return appPath;
};

InterfaceService.prototype.getAndroidApplicationId = async function () {
  const appPath = await this.getAppPath();
  if (appPath.isSuccessful()) {
    const body = appPath.body();
    if (body.startsWith('$4/')) {
      // TODO replace with constant
      appPath.setBody(body.substring(3));
    } else {
      appPath.setBody('');
    }
  }
  return appPath;
};

InterfaceService.prototype.putAndroidApplicationId = async function (
  value: string,
) {
  return this.putAppPath(`$4/${value}`);
};
